// src/api/projects.ts
import { API_BASE, parseJsonSafe } from "./api";
import { ApiProject } from "../api/api";

export async function fetchProjects() {
    const username = localStorage.getItem("username") ?? "";
    const res = await fetch(`${API_BASE}/projects?username=${encodeURIComponent(username)}`);
    if (!res.ok) throw new Error("Failed to fetch projects");
    return await parseJsonSafe(res, null);
}

export async function createProject(data: { title: string; description?: string }) {
    const username = localStorage.getItem("username") ?? "";
    const res = await fetch(`${API_BASE}/projects?username=${encodeURIComponent(username)}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error("Failed to create project");
    return await parseJsonSafe(res, null);
}

export const fetchProject = async (id: number): Promise<ApiProject> => {
  const username = localStorage.getItem("username") ?? "";
  const res = await fetch(`${API_BASE}/projects/${id}?username=${encodeURIComponent(username)}`);
  if (!res.ok) throw new Error("Failed to fetch project");
  return res.json();
};


export async function updateProject(projectId: number, data: { title: string; description?: string }) {
    const res = await fetch(`${API_BASE}/projects/${projectId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error("Failed to update project");
    return res.json().catch(() => data);
}

export async function deleteProject(id: number) {
    const res = await fetch(`${API_BASE}/projects/${id}`, { method: "DELETE" });
    if (!res.ok) throw new Error("Failed to delete project");
}

// src/api/projects.ts (انتهای فایل اضافه کنید)

export interface ShareProjectResult {
  code: string;
  sharedWith: {
    username: string;
    displayName: string;
  };
}

export async function shareProject(projectId: number, targetUsername: string): Promise<ShareProjectResult> {
  const username = localStorage.getItem("username") ?? "";
  if (!username) throw new Error("User not logged in");

  const res = await fetch(
    `${API_BASE}/projects/${projectId}/shares?username=${encodeURIComponent(username)}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ targetUsername: targetUsername.trim() })
    }
  );

if (!res.ok) {
  const err = await parseJsonSafe(res, { code: "UNKNOWN_ERROR" });
  throw new Error(err.code);
}

  return await parseJsonSafe(res, null);
}